const CUISINE_TYPES_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  initialData: [],
  latestEvent: undefined,
  data: [],
  isDirty: false,
  dataForRenaming: undefined,
  mainTreeExpandedKeys: [],
  supportingTreeExpandedKeys: [],
}

export default CUISINE_TYPES_INITIAL_STATE
